import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FolderService } from '@service/folder/folder.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-charges-comptant-generate',
  templateUrl: './charges-comptant-generate.component.html'
})
export class ChargesComptantGenerateComponent implements OnInit {

  moisCible: string = '';
  loading: boolean = false;
  rapport: any = null;

  constructor(
    public modal: NgbActiveModal,
    private folderService: FolderService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const now = new Date();
    this.moisCible = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
  }

  generer(): void {
    if (!this.moisCible) {
      this.toastr.warning('Veuillez saisir un mois cible.', 'Attention');
      return;
    }

    this.loading = true;
    this.rapport = null;

    this.folderService.generateChargesComptant({ mois: this.moisCible }).subscribe(
      (res: any) => {
        this.loading = false;
        if (res?.status === 'success') {
          this.rapport = res.data;
          this.toastr.success(res.message, 'Succes');
        } else {
          this.toastr.error(res?.message || 'Erreur inconnue', 'Erreur');
        }
      },
      (error: any) => {
        this.loading = false;
        this.toastr.error('Erreur lors de la generation des charges.', 'Erreur');
      }
    );
  }

  getBadgeClass(statut: string): string {
    switch (statut) {
      case 'GENERE': return 'badge-success';
      case 'DOUBLON': return 'badge-warning';
      case 'ERREUR': return 'badge-danger';
      default: return 'badge-secondary';
    }
  }
}
